/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_DISPLAY_COOLER_TRENDING_PRODUCTS_STATS = gql`
  query DisplayCoolerTrendingProductsStats(
    $displayId: ID!
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    displayCoolerTrendingProductsStats(
      displayId: $displayId
      startDate: $startDate
      endDate: $endDate
    ) {
      mostIncreasingProduct {
        upc
        name
        revenue
        revenueTrend
      }
      mostDecreasingProduct {
        upc
        name
        revenue
        revenueTrend
      }
      risingProducts {
        upc
        name
        revenue
        revenueTrend
      }
      fallingProducts {
        upc
        name
        revenue
        revenueTrend
      }
    }
  }
`
